enum ModalityQueryParamsEnum {
	MEDICAL_APPOINTMENT = 'consulta',
	SPECIAL_EXAMS = 'exames-especiais',
	SIMPLE_EXAMS = 'exames-simples',
	HOSPITALIZATIONS = 'internacao',
	EMERGENCY = 'pronto-socorro',
	THERAPIES = 'terapias',
}

enum TypeProviderQueryEnum {
	PHYSICAL_PERSON = 'pessoa-fisica',
	LEGAL_PERSON = 'pessoa-juridica',
}

export {ModalityQueryParamsEnum, TypeProviderQueryEnum};
